/**
 * Position Options
 * Options for user positions in the team
 * @type {Array}
 */
export const POSITION_OPTIONS = [
    { value: "account-manager", label: "Account Manager" },
    { value: "administration-finance", label: " Administration & Finance" },
    { value: "co-founder-cto", label: "Co-Founder & CTO" },
    { value: "co-founder-coo", label: "Co-Founder & COO" },
    { value: "co-founder-ceo", label: "Co-Founder & CEO" },
    {
        value: "customer-service-representative",
        label: "Customer Service Representative"
    },
    {
        value: "customer-service-manager",
        label: "Customer Service Manager"
    },
    {
        value: "customer-service-claims-manager",
        label: "Customer Service & Claims Manager"
    },
    { value: "data-entry-operator", label: "Data Entry Operator" },
    { value: "designer-front-end", label: "Designer & Front End" },
    { value: "developer", label: "Developer" },
    {
        value: "junior-reservations-sales-agent",
        label: "Junior Reservations & Sales Agent"
    },
    { value: "product-manager", label: "Product Manager" },
    {
        value: "reservations-csr-manager",
        label: "Reservations & CSR Manager"
    },
    {
        value: "reservations-sales-agent",
        label: "Reservations & Sales Agent"
    },
    { value: "sales-manager", label: "Sales Manager" }
];

/**
 * Roles Options
 * Options for user roles in the team
 * @type {Array}
 */
export const ROLES_OPTIONS = [
    { value: "super_admin", label: "Super Admin" },
    { value: "admin", label: "Admin" },
    { value: "manager", label: "Manager" },
    { value: "support", label: "Support" },
    { value: "user", label: "User" }
];

/**
 * Teams Fields
 * Table columns for Teams view
 * @type {Array}
 */
export const TEAMS_FIELDS = [
    {
        key: "selected",
        label: "",
        sortable: false,
        class: "text-center",
        thStyle: { minWidth: "40px" }
    },
    {
        key: "username",
        label: "Member",
        sortable: true,
        thStyle: { minWidth: "120px" },
        class: "text-left"
    },

    {
        key: "position",
        label: "Position",
        sortable: true,
        thStyle: { minWidth: "100px" },
        class: "alinmov6"
    },

    {
        key: "email",
        label: "Email",
        sortable: true,
        thStyle: { minWidth: "150px" },
        class: "text-left"
    },
    {
        key: "role",
        label: "Role",
        sortable: true,
        thStyle: { minWidth: "100px" },
        class: "alinmov6"
    },
    {
        key: "status",
        label: "Status",
        sortable: true,
        thStyle: { minWidth: "100px" },
        class: "alinmov6"
    },
    {
        key: "actions",
        label: "Actions",
        sortable: false,
        class: "alinmov6",
        thStyle: { minWidth: "80px" }
    }
]

/**
 * Sort Table Options
 * Options for sorting the Teams table
 * @type {Array}
 */
export const SORT_TABLE_OPTIONS = [
    {
        value: "member",
        text: "Member"
    },
    {
        value: "position",
        text: "Position"
    },
    { value: "role", text: "Role" }
]